import { render, staticRenderFns } from "./BuscasRecentes.vue?vue&type=template&id=aa9bbe4a"
import script from "./BuscasRecentes.vue?vue&type=script&lang=js"
export * from "./BuscasRecentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports